import React, { Component } from 'react';
import { Form, Icon, Input, Button, Card, Row, Col, message } from 'antd';
import PubNubReact from 'pubnub-react';
import './App.css';

const FormItem = Form.Item;

class LoginForm extends Component {

  constructor(props){
    super(props);
    this.state = {
      message: "Enter your publish and subscribes keys, then send a message!"
    };
    this.pubnub = new PubNubReact({
      publishKey: '',
      subscribeKey: ''
    });
    this.pubnub.init(this);
  }
  
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.pubnub = new PubNubReact({
          publishKey: values.PubKey,
          subscribeKey: values.SubKey
        });
        this.pubnub.init(this);
        this.forceUpdate();
      }
    });
  }
  sendData = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        try {
          this.pubnub.subscribe({
            channels: ['data_channel'],
            withPresence: true
          });
          this.pubnub.getMessage('data_channel', (msg) => {
            this.setState({message:msg.message})
          });
          message.success('Data sent successfully!');
        } catch (error) {
          message.error('Make sure you function is publishing to the "data_channel" channel');
        }
        return this.pubnub.publish({
          message: values.Data,
          channel: 'data_channel'
        });
      }
    });
  }

  componentWillUnmount() {
    this.pubnub.unsubscribe({
        channels: ['data_channel']
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="gutter">
        <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            <Card title="PubNub Keys">
              <Form style={{width:'inherit'}} onSubmit={this.handleSubmit} className="login-form">
                <FormItem>
                  {getFieldDecorator('PubKey', {
                    rules: [{ required: true, message: 'please enter your publish key' }],
                  })(
                    <Input prefix={<Icon type="arrow-up" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="pub-xxxxxxx" />
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('SubKey', {
                    rules: [{ required: true, message: 'please enter your subscribe key' }],
                  })(
                    <Input prefix={<Icon type="arrow-down" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="sub-xxxxxxxx" />
                  )}
                </FormItem>
                <FormItem>
                  <Button type="primary" htmlType="submit" className="setKeys">
                    Set Keys
                  </Button>
                </FormItem>
              </Form>
            </Card>
          </Col>
          <Col className="gutter-row" span={6}>
            <Card title="Data To Send">
              <Form style={{width:'inherit'}} onSubmit={this.sendData} className="login-form">
                <FormItem>
                  {getFieldDecorator('Data', {
                    rules: [{ required: true, message: 'Enter Data to Send' }],
                  })(
                    <Input prefix={<Icon type="api" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="data to be published" />
                  )}
                </FormItem>
                <FormItem>
                  <Button type="primary" htmlType="submit" className="sendData">
                    Send
                  </Button>
                </FormItem>
              </Form>
            </Card>
          </Col>
          <Col className="gutter-row" span={6}>
            <Card title="Returned Data">
                  <h1> {this.state.message} </h1>
            </Card>
          </Col>
        </Row>
        <h1> 
          Checkout the original article at <a href="https://www.pubnub.com/blog/serverless-microservices-with-pubnub-functions/">PubNub!</a>
        </h1>
        <Row type="flex" justify="center"> 
          <a href="https://github.com/nxsyed/Microservices"> 
            <Icon type="github" style={{ fontSize: 40}}/> 
          </a>
          <a href="https://twitter.com/nxsyed"> 
            <Icon type="twitter" style={{ fontSize: 40}}/>
          </a>
          <a href="https://www.linkedin.com/in/nxsyed"> 
            <Icon type="linkedin" style={{ fontSize: 40}}/> 
          </a>
          <a href="https://www.instagram.com/nxsyed/">
            <Icon type="instagram" style={{ fontSize: 40 }}/>
          </a>
          <a href="https://medium.com/@nxsyed"> 
            <Icon type="medium" style={{ fontSize: 40}}/> 
          </a>
        </Row>
      </div>
    );
  }
}

const App = Form.create()(LoginForm);

export default App;


// WEBPACK FOOTER //
// ./src/App.js